import React from 'react'

const Footer = () => {
    return (
      <div className="footer">
        Copyright © Kolkata Couture Expo (KCE). All Rights Reserved.
      </div>
    );
}

export default Footer